import React, { FC } from 'react';
import { View } from 'react-native';
import { connect } from 'react-redux';
import { getToolById } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getNCFileById } from '@reducers/manufacture';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { useToolDetails } from '@v2/pages/common/hooks/useToolsDetails';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import NCFileBatchEvents from '@v2/pages/common/components/NCFileBatchEvents';
import { NcFileBatchEventType } from '@v2/pages/common/enums';

interface ToolsDetailsNCFileEventsActiveProps {
  ncFileId: number | null;
}

const ToolsDetailsNCFileEventsActiveComponent: FC<ToolsDetailsNCFileEventsActiveProps> = ({
  getToolById,
  updateHeaderConfig,
  getNCFileById,
  ncFileId,
}) => {
  const title = useTitle();

  useToolDetails({
    getToolById,
    updateHeaderConfig,
    getNCFileById,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <View style={{ flex: 1 }}>
        <NCFileBatchEvents {...{ eventType: NcFileBatchEventType.ACTIVE, ncFileId }} />
      </View>
    </DetailsPageWrapper>
  );
};

const ToolsDetailsNCFileEventsActive = connect(({ details: { ncFileId } }) => ({ ncFileId }), {
  getToolById,
  updateHeaderConfig,
  getNCFileById,
})(ToolsDetailsNCFileEventsActiveComponent);

export { ToolsDetailsNCFileEventsActive };
